import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'

// create an axios instance
// create an axios instance
const service = axios.create({
  baseURL: `${window.location.protocol}//${window.location.host}`,
  //baseURL: 'http://localhost:8081',
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000, // request timeout
  showLoading: true
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    console.log('request=>', config)
    if(config.url.indexOf("jsp/loginman.jsp") > 0){
      config.baseURL = `${window.location.protocol}//${window.location.host}`;
    }
    if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      config.data = qs.stringify(config.data)
    }
    return config
  },
  error => {
    // do something with request error
    console.log('request.error=>', error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    console.log('response=>', response)

    const res = response.data

    if (res.code < 0) {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 2 * 1000
      })

      return Promise.reject(res.msg || 'Error')
    } else {
      return res
    }
  },
  error => {
    console.log('response.error=>', error) // for debug
    if (error.response.status === 500) {
      // Message.error('serve error')  // 返回状态等于500时提示
    } else {
      Message({
        message: error.message || 'Error',
        type: 'error',
        duration: 2 * 1000
      })
      return Promise.reject(error)
    }
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js